// Hiusextra: ostoskorin lisämyyntituotteiden lisäys koriin (snippets/hx-cart-upsell.liquid). Lähettää saman
// CartLinesUpdateEvent-tapahtuman kuin teeman product-form.js, joten ostoskoriosiot päivittyvät palvelimen
// HTML:llä (myös tämä lista, josta lisätty tuote poistuu).
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { QuickAddComponent } from '@theme/quick-add';

// Vaihtoehdollinen tuote avaa teeman pikaostosnäkymän. QuickAddComponent hakee tuotteen osoitteen
// tuotekortista; tässä se tulee data-attribuutista.
class HxQuickAdd extends QuickAddComponent {
  get productPageUrl() {
    return this.dataset.productUrl || '';
  }
}
if (!customElements.get('hx-quick-add')) customElements.define('hx-quick-add', HxQuickAdd);

// Nuolet vierittävät listaa.
function updateArrows(list) {
  var wrap = list.closest('.hx-cart-upsell');
  if (!wrap) return;
  var arrows = wrap.querySelectorAll('[data-hx-upsell-scroll]');
  var max = list.scrollWidth - list.clientWidth;
  wrap.classList.toggle('hx-cart-upsell--fits', max <= 1);
  if (arrows.length < 2) return;
  arrows[0].disabled = list.scrollLeft <= 1;
  arrows[1].disabled = list.scrollLeft >= max - 1;
}

document.addEventListener('click', function (event) {
  var target = event.target instanceof Element ? event.target : null;
  var quick = target && target.closest('[data-hx-quick-add]');
  if (quick) {
    var component = quick.closest('hx-quick-add');
    if (!component) return;
    if (!document.getElementById('quick-add-dialog')) {
      window.location.href = component.dataset.productUrl;
      return;
    }
    component.handleClick(event);
    return;
  }
  var arrow = target && target.closest('[data-hx-upsell-scroll]');
  if (arrow) {
    var list = arrow.closest('.hx-cart-upsell')?.querySelector('.hx-cart-upsell__list');
    var item = list && list.querySelector('.hx-cart-upsell__item');
    if (!list || !item) return;
    list.scrollBy({ left: Number(arrow.getAttribute('data-hx-upsell-scroll')) * (item.offsetWidth + 12), behavior: 'smooth' });
  }
});

document.addEventListener(
  'scroll',
  function (event) {
    var list = event.target;
    if (list instanceof Element && list.classList.contains('hx-cart-upsell__list')) updateArrows(list);
  },
  true
);

// Nuolten tila, kun lista tulee näkyviin tai ostoskori päivittyy (paneeli on suljettuna leveydeltään 0).
var observed = new WeakSet();
var resize = new ResizeObserver(function (entries) {
  entries.forEach(function (entry) {
    updateArrows(entry.target);
  });
});
function watch() {
  document.querySelectorAll('.hx-cart-upsell__list').forEach(function (list) {
    if (observed.has(list)) return;
    observed.add(list);
    resize.observe(list);
  });
}
watch();
new MutationObserver(watch).observe(document.body, { childList: true, subtree: true });

document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-hx-upsell')) return;
  event.preventDefault();

  var button = form.querySelector('button[type="submit"]');
  if (button) {
    if (button.disabled) return;
    button.disabled = true;
  }

  var variantId = String(new FormData(form).get('id'));
  var sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach(function (item) {
    if (item instanceof HTMLElement && item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
  });

  var deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  var fail = function (message) {
    deferred.reject(new Error(message));
    form.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }));
    if (button) button.disabled = false;
  };

  fetch(Theme.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (response) {
      if (response.status) return fail(response.description || response.message || 'Add to cart failed');
      return fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'hx-cart-upsell',
              itemCount: 1,
              sections: response.sections,
              didError: false,
            },
          });
        });
    })
    .catch(function (error) {
      fail(error && error.message ? error.message : 'Network error during add to cart');
    });
});
